import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import { save, cancel, loadTokens } from '../actions/account'
import Tabs from '../components/ui/Tabs'
import ApiToken from '../components/ApiToken'
import Table from '../components/Table'

import AccountPlan from './AccountPlan'
import AccountBilling from './AccountBilling'

import NoAccount from '../components/help/NoAccount'
import UpdateProfile from '../components/account/UpdateProfile'

@connect(state => ({account: state.auth.account, tokens: state.auth.tokens}),
  {save, cancel, loadTokens})
export default class AccountSettings extends Component {
  componentDidMount () {
    const {tokens, loadTokens} = this.props
    if (!tokens.length) loadTokens()
  }

  onDeleteAccount = e => {
    e.preventDefault()
    this.props.cancel()
  }

  onSave = values => {
    return this.props.save(values)
  }

  render () {
    const {user, account, tokens} = this.props

    return <div className='account-settings'>
      {!account && <NoAccount user={user} />}
      {!!account &&
        <div>
          <div className='information account-plan'>
            <Tabs>
              <Route title='Profile' exact path='/dashboard/account' render={() =>
                <div>
                  <div className='information'>
                    <UpdateProfile value={account} onSubmit={this.onSave} />
                  </div>
                  <div className='information'>
                    <h3 className='information-header'>Tokens</h3>
                    <Table columns={['Name', 'Last Active', 'Secret', 'Actions']}>
                      {tokens.map(token =>
                        <ApiToken token={token} key={token.id} />
                      )}
                    </Table>
                  </div>
                  <div className='information danger'>
                    <h3 className='information-header'>Delete Account</h3>
                    <p>This will permanently delete all Fridge data associated with this account. There is no going back. Please know what you are doing.</p>
                    <button className='btn' onClick={this.onDeleteAccount}>Delete</button>
                  </div>
                </div>
              } />
              <Route title='Billing' exact path='/dashboard/account/billing'
                component={AccountBilling} />
              <Route title='Plan' exact path='/dashboard/account/plan'
                component={AccountPlan} />
            </Tabs>
          </div>
        </div>
      }
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/containers/AccountSettings.js